import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

import account from "../modules/account"
import createCmaj from "../modules/createCmaj"
import web_form from "../modules/web-form/webform"
import providerFilter from "../modules/providerFilter"
import cmajFilter from "@/modules/cmajFilter"
import resource from "../modules/resource"
import createAccount from "@/modules/createAccount"
import preview from "../modules/preview"
import createCadh from "../modules/createCadh"
import cadhFilter from "../modules/cadhFilter"
import aura from "../modules/aura"
import pro from "../modules/pro"
import global from "../modules/global"
import campaignFilter from "../modules/campaignFilter"
import connexionFilter from "../modules/connexionFilter"
import webFormStyle from "../modules/webFormStyle"
import tracking from "../modules/tracking"
import cadhConfig from "../modules/cadhConfig"
import forbiddenCriteria from "../modules/web-form/forbiddenCriteria"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        createCmaj: createCmaj,
        account: account,
        web_form: web_form,
        providerFilter: providerFilter,
        cmajFilter: cmajFilter,
        cadhFilter: cadhFilter,
        campaignFilter: campaignFilter,
        connexionFilter: connexionFilter,
        resource: resource,
        createAccount: createAccount,
        createCadh: createCadh,
        preview: preview,
        aura: aura,
        pro: pro,
        webFormStyle: webFormStyle,
        global: global,
        tracking: tracking,
        cadhConfig: cadhConfig,
        forbiddenCriteria: forbiddenCriteria,
    },
    plugins: [
        createPersistedState({
            paths: ["account", "providerFilter", "preview", "pro", "global", "campaigns", "webFormStyle"],
        }),
    ],
})
